// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","button":"card-button_button__N5He1","investmentOpportunities":"card-button_investmentOpportunities__WYA5i"};